import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { duLieuHeThong } from 'base/reducers/duLieuHeThong';
import { baoCaoDinhKy } from 'base/reducers/baoCaoDinhKy';
import { baoCaoTongHop } from 'base/reducers/baoCaoTongHop';
import { danhSachKHThanhTra } from 'base/reducers/danhSachKHThanhTra';
import { formDataTiepCongDan } from 'base/reducers/formDataTiepCongDan';
import { dataList } from 'base/reducers/dataList';
import { dataCuocThanhTra } from 'base/reducers/dataCuocThanhTra';
import { xuLyTrung } from 'base/reducers/xuLyTrung';

let rootReducer = combineReducers({
  duLieuHeThong: duLieuHeThong,
  baoCaoDinhKy: baoCaoDinhKy,
  baoCaoTongHop: baoCaoTongHop,
  danhSachKHThanhTra: danhSachKHThanhTra,
  dataList,
  dataCuocThanhTra,
  xuLyTrung,
  formDataTiepCongDan: formDataTiepCongDan,
  routing: routerReducer
});

export { rootReducer };



// WEBPACK FOOTER //
// ./src/reducers/index.js